import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import ClearIcon from './ClearIcon';
import { useFormats } from '@portal/hooks/use-formats';
import { getCustomFormattedDate } from '@portal/util/datetime-formatter';

interface DatePickerCompProps {
  onChange: (value?: string) => void;
  value?: dayjs.Dayjs;
  style?: React.CSSProperties;
  isEditable?: boolean;
}

export default function DatePickerComp(props: DatePickerCompProps) {
    const { dateformat } = useFormats();

  // Handle date change
  const handleDateChange = (newDate: dayjs.Dayjs) => {
    const date = getCustomFormattedDate(newDate, 'YYYY-MM-DD');
    props.onChange(newDate ? date : newDate);
  };

  return (
    <div style={props.style}>
      <DatePicker  
        size="middle"
        allowClear={{
          clearIcon: <ClearIcon />,
        }}
        defaultValue={props.value}
        style={props.style}
        onChange={handleDateChange}
        format={dateformat}
        popupAlign={{ overflow: { adjustY: true } }}
        variant={'outlined'}
        disabled={!props.isEditable}
      />
    </div>
  );
}
